import { useEffect } from "react";
import { useParams } from "react-router-dom";

/* Articles are static HTML — redirect the SPA to the HTML file */
export default function ArticlePage() {
  const { slug } = useParams();
  useEffect(() => { window.location.href = `/articles/${slug}.html`; }, [slug]);
  return null;
}
